<template>
    <div>
        <LsInputLabel
            v-if="label"
            :label="label"
            :sub-label="subLabel"
            :collapse-content="collapseContent"
            :error="getValidation.invalid"
        />
        <BField :type="{ 'is-error': getValidation.invalid }">
            <section :class="{ 'ls-radios--section': columns }">
                <div v-for="option in options" :key="option.key || option.label" class="field">
                    <BRadio
                        v-model="localValue"
                        v-validate="validation"
                        :name="name"
                        :native-value="option.value"
                        :disabled="option.disabled || disabled"
                        test-id="ls-radio"
                        :class="{ 'ls-radios--has-sub-label': Boolean(option.subLabel) }"
                    >
                        <div class="ls-radios--option-labels">
                            <span class="ls-radios--option-label">{{ option.label }}</span>
                            <span v-if="option.subLabel" class="ls-radios--option-sub-label">{{
                                option.subLabel
                            }}</span>
                        </div>
                    </BRadio>
                </div>
            </section>
        </BField>
    </div>
</template>

<script>
import { lsPropTypeHelpers, lsTrackingService, lsValidationService } from 'ls-vue-common';
import VueTypes from 'vue-types';
import _ from 'lodash';
import { LsInputLabel } from '@/components/common';

export default {
    name: 'LsRadios',
    inject: ['$validator'],
    components: {
        LsInputLabel,
    },
    props: {
        value: VueTypes.any.isRequired,
        trackId: VueTypes.custom(lsPropTypeHelpers.trackID).isRequired,
        name: VueTypes.string.isRequired,
        options: VueTypes.arrayOf(
            VueTypes.shape({
                label: VueTypes.string.isRequired,
                subLabel: VueTypes.string,
                value: VueTypes.any.isRequired,
                disabled: VueTypes.bool,
                key: VueTypes.oneOfType([String, Number]),
            })
        ).isRequired,
        label: VueTypes.string,
        subLabel: VueTypes.string,
        collapseContent: VueTypes.string,
        disabled: VueTypes.bool.def(false),
        validation: VueTypes.object.def(_.constant(null)),
        columns: VueTypes.bool.def(false),
    },
    computed: {
        localValue: {
            get() {
                return this.value;
            },
            set(value) {
                lsTrackingService.track({
                    event: 'click',
                    target: this.trackId,
                    data: { value },
                });
                this.$emit('input', value);
            },
        },
        getValidation() {
            return lsValidationService.getValidation.call(this);
        },
    },
};
</script>

<style lang="scss">
.b-radio {
    .control-label {
        padding-left: 9px !important;
    }

    .check {
        border: 1px solid $secondary !important;
        height: 1.2rem !important;
        width: 1.2rem !important;
        &:before {
            height: 1rem !important;
            width: 1rem !important;
            margin-left: -0.5rem !important;
            margin-bottom: -0.5rem !important;
        }
    }

    .ls-radios--option-labels {
        display: flex;
        flex-direction: column;
    }

    .ls-radios--option-label {
        padding-top: 1px;
        color: $secondary;
    }

    .ls-radios--option-sub-label {
        margin-top: 3px;
        color: $gray-primary !important;
    }
}

.ls-radios--has-sub-label {
    align-items: flex-start !important;
    .check {
        margin-top: 2px;
    }
}

.b-radio.radio input[type='radio']:checked + .check {
    border-color: $primary !important;
}
</style>
